export default class NavbarWidget {
    constructor(el, options = {}) {
        this.el = el;
        this.options = options;
        this.init();
    }

    init() {
        const element = this.el;
        const collapse = element.querySelector('.navbar-collapse');

        collapse.addEventListener('show.bs.collapse', () => {
            document.body.classList.add('collapse-open');
        });

        collapse.addEventListener('hide.bs.collapse', () => {
            document.body.classList.remove('collapse-open');
        });

        // Add scroll listener to toggle 'is-scrolled' class
        const handleScroll = () => {
			//console.log(window.scrollY);
            if (window.scrollY > 10) {
                document.body.classList.add('is-scrolled');
            } else {
                document.body.classList.remove('is-scrolled');
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Check initial scroll position on load
        handleScroll();
    }
}
